// extracted by mini-css-extract-plugin
export default {"text":"CalcPage_text__tjUGe","title":"CalcPage_title__DRrLH","grid":"CalcPage_grid__D9kbT"};